import apiClient from '../../../common/functions/api_axios_instance.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const createNewTeam = async (data) => {
  try {
    const response = await apiClient.post('/teamManagement', data);
    return { success: true, data: response.data };
  } catch (error) {
    console.log(error);
    const errorMessage = error.response?.data?.error || 'Failed to create team';
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
